import React from "react";

interface OzoneIconProps {
  width?: string;
  height?: string;
  fillColor?: string; // цвет заливки фона иконки
  pathColor?: string; // цвет пути иконки
  strokeColor?: string; // цвет рамки
}

export const OzoneIcon: React.FC<OzoneIconProps> = ({
  width = "20",
  height = "20",
  fillColor = "fill-blue-600",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`border rounded `}
    >
      <rect width="48" height="48" rx="8" className={`${fillColor}`} />
      <text
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize="12"
        fill="white"
        fontWeight="bold"
        letterSpacing="1"
      >
        OZON
      </text>
    </svg>
  );
};
